import styled from 'styled-components';

export default styled.section`
  padding: 0 ${props => props.theme.padding.inner} 0;

  .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.post};
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transition: all 0.4s ease-in-out;
      }
    }

    .active& {
      opacity: 1;
    }

    .module {
      margin: 3rem 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }

      picture,
      img,
      figure {
        display: block;
        width: 100%;
        border-radius: 4px;
        overflow: hidden;
      }

      iframe {
        border-radius: 4px;
        overflow: hidden;
        padding-bottom: 5px;
      }

      header {
        margin-bottom: 1rem;
      }

      h3 {
        margin: 0 0 0.5rem;
      }

      h4 {
        margin-top: 0;
        font-weight: 400;
      }

      &--reverse {
        header {
          margin-top: 1rem;
          margin-bottom: 0;
        }
      }
    }
  }
`;
